module.exports = __webpack_public_path__ + "static/media/day-2.6dd93d88.jpg";